<template>
    <!-- Filters -->
    <el-form label-position="top"> 
        <div class="d-flex align-items-end mb-3" :style="{ gap: '12px' }">
            <!-- Distribuidor -->
            <div>
                <label>Distribuidor</label>
                <el-input
                    v-model="filters.nome"
                    size="small"
                    placeholder="Nome do distribuidor"
                    :disabled="isLoading"
                    @keyup.enter.native="handleDispatch()"
                />
            </div>

            <!-- UF -->
            <div>
                <label>Estados</label>
                <el-select
                    v-model="filters.estado"
                    size="small"
                    placeholder="Estados"
                    :disabled="isLoading"
                    filterable 
                    clearable
                >
                    <el-option :value="null">Todos</el-option>
                    <el-option
                        v-for="uf in estados"
                        :key="uf.value"
                        :label="uf.text"
                        :value="uf.value"
                    >
                    </el-option>
                </el-select>
            </div>

            <!-- Status -->
            <div>
                <label>Status</label>
                <el-select
                    v-model="filters.status"
                    size="small"
                    placeholder="Status"
                    :disabled="isLoading"
                    filterable
                    clearable
                >   
                    <el-option :value="null">Todos</el-option>
                    <el-option
                        v-for="(stat) in [
                            { value: 'IMPORTADO', text: 'Importado' },
                            { value: 'PENDENTE', text: 'Pendente' },
                            { value: 'FALHA_CONTATO', text: 'Falha no Contato' },
                        ]"
                        :key="stat.value"
                        :label="stat.text"
                        :value="stat.value"
                    />
                </el-select>
            </div>

            <!-- Datas -->
            <div>
                <label>Período</label>
                <el-date-picker
                    unlink-panels
                    size="small"
                    v-model="filters.periodo"    
                    type="daterange"
                    start-placeholder="Inicio"
                    end-placeholder="Fim"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                />
            </div>   

            <!-- Acoes -->
            <div>
                <el-button
                    size="small" 
                    circle 
                    plain
                    :disabled="isLoading || shouldBeClear"
                    @click="clean()"
                >
                    <i class="el-icon-delete"></i>
                </el-button>

                <el-button 
                    size="small" 
                    :disabled="isLoading" 
                    @click="handleDispatch()"
                >
                    <i class="fas fa-search"></i>
                    Buscar
                </el-button>
            </div>
        </div>
    </el-form>
</template>
<script>
    import {
        Form,
        Input,
        Select,
        Option,
        DatePicker,
        Notification,
        Button,
        Loading,
    } from 'element-ui'

    export default {
        props: {
            isLoading: false,
        },
        data() {
            return {    
                filters: {
                    nome: null,
                    estado: null,
                    status: null,
                    periodo: null,
                },
                estados: [],
                loadingInstance: null
            }
        },
        methods: {
            async getEstados() {
                axios.get('/estados').then((response) => {
                    let data = response.data

                    data.forEach((a, b) => {
                        this.estados.push({ 
                            value: a.uf, 
                            text: a.uf
                        })
                    })
                }).catch((errors) => {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os estados!'
                    });
                });
            },
            handleDispatch() {
                this.$emit('dispatch', { ...this.filters })
            },
            clean() {
                this.filters = {
                    nome: null,
                    estado: null,
                    status: null,
                    periodo: null,
                };

                this.handleDispatch();
            },
        },  
        computed: {
        shouldBeClear() {
                const { nome, estado, status, periodo } = this.filters;
                return !nome && !estado && !status && !periodo;
            }
        },
        mounted() {
            this.getEstados();
        },
        watch: {
            isLoading(_newValue) {
                if (_newValue) {
                    this.loadingInstance = this.$loading({
                        customClass: 'loader-indicative-bottom-right'
                    })

                    return
                }

                if (this.loadingInstance) {
                    this.loadingInstance.close()
                    this.loadingInstance = null
                }
            }       
        },
        components: {
            [Notification.name]: Notification,
            [Loading.name]: Loading,
            [Form.name]: Form,
            [Input.name]: Input,
            [Select.name]: Select,
            [Option.name]: Option,
            [DatePicker.name]: DatePicker,
            [Notification.name]: Notification,
            [Button.name]: Button,
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/indicados/distribuidores_indicados/Filters.vue